module.exports = __webpack_public_path__ + "img/arrow-right-circle.483d685a.svg";